/**
 * public/ 目录下的静态资源 URL，与 Vite `base`（如 `./`）对齐。
 * 避免在子路径部署时使用 `/audio/...` 误请求到站点根导致 404。
 */
export function publicUrl(path: string): string {
  const base = import.meta.env.BASE_URL;
  const trimmed = path.startsWith("/") ? path.slice(1) : path;
  if (base === "/" || base === "") {
    return "/" + trimmed;
  }
  return base.endsWith("/") ? base + trimmed : `${base}/${trimmed}`;
}
